var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetsreadlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.65;fill:url(#SVGID_1_);}\r\n\t.st1{stroke:#000000;stroke-width:1.5858;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:1.5858;stroke-miterlimit:10;}\r\n\t.st3{stroke:#000000;stroke-width:1.6132;stroke-miterlimit:10;}\r\n\t.st4{fill:url(#SVGID_00000040532831816489704400000004775488013729175939_);}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 612,
    height: 502,
    xlinkHref: "../../Desktop/istockphoto-877235850-612x612.jpg",
    transform: "matrix(0.9856 0 0 0.996 26 69)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.2608,
    y1: 444,
    x2: 250.2608,
    y2: 350.3019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3929,
    style: {
      stopColor: "#EAE8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5344,
    style: {
      stopColor: "#EAE1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    style: {
      stopColor: "#EBD6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7169,
    style: {
      stopColor: "#ECC5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7868,
    style: {
      stopColor: "#ECAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#EE9393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    style: {
      stopColor: "#EF7373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9544,
    style: {
      stopColor: "#F04F4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F22626"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,444c24.6-18.9,99.7-97.4,224.2-93.6C361,353.8,448.4,424,474.5,444c-34.4-20.5-118.3-71-224.2-72.6 C136.8,369.7,60.4,423.6,26,444z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.2,142.3c-19.7-11.6-46.8-24.4-80.7-32.3c-15.2-3.5-29.3-5.5-41.9-6.5C80,139.4,90.2,176,100.2,213.3 c9.7,36,18.8,71.5,27.4,106.5c13.7-1.1,30.8-1.2,50,1.6c31.6,4.7,56.3,15.4,72.6,24.2c-11.6-8.2-28.3-18.2-50-25.8 c-23.7-8.3-44.8-10.7-59.7-11.3c-8-54.7-21.2-112.1-41.9-171c-2.1-6-4.3-11.9-6.5-17.7c14.2,2,29.3,4.6,45.2,8.1 C157.2,132.1,175.5,137.1,192.2,142.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.6,76.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.5,344.8c-22.7-1.3-50.7-1.1-82.3,3.2c-29.7,4.1-55.2,10.8-75.8,17.7c-3.7-25.4-9.7-54.3-19.4-85.5 c-14.4-46.4-32.9-84.8-50-114.5c11.8,0,23.7,0,35.5,0c2.2,0,4.3,0,6.5,0c0,2.2,0,4.3,0,6.5c-2.9-0.3-7.6-0.3-12.9,1.6 c-2.6,0.9-4.8,2.1-6.5,3.2c11.5,21.4,23.4,46.7,33.9,75.8c13.4,37.2,21.2,71.3,25.8,100c5-2.1,12.8-5.2,22.6-8.1 c8.2-2.4,42.6-11.9,88.7-6.5C223.9,339.3,235.6,341.1,249.5,344.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.6,345.6c-18.4-3.3-40.1-5.9-64.5-6.5c-27.7-0.6-52.2,1.7-72.6,4.8c-7.9-43.9-20.1-92.9-38.7-145.2 c-8.2-22.9-16.9-44.4-25.8-64.5c13.4,0.5,26.9,1.1,40.3,1.6c0,2.2,0,4.3,0,6.5c-3-0.7-7.6-1.2-12.9,0c-1.8,0.4-3.5,1-4.8,1.6 c5.5,14.6,10.9,29.6,16.1,45.2c16.4,49.3,28.4,96.4,37.1,140.3c12.7-1.6,27.4-2.4,43.6-1.6C200.5,329.5,228.6,337.7,248.6,345.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.9,142.3c19.7-11.6,46.8-24.4,80.7-32.3c15.2-3.5,29.3-5.5,41.9-6.5c-10.4,35.8-20.6,72.4-30.6,109.7 c-9.7,36-18.8,71.5-27.4,106.5c-13.7-1.1-30.8-1.2-50,1.6c-31.6,4.7-56.3,15.4-72.6,24.2c11.6-8.2,28.3-18.2,50-25.8 c23.7-8.3,44.8-10.7,59.7-11.3c8-54.7,21.2-112.1,41.9-171c2.1-6,4.3-11.9,6.5-17.7c-14.2,2-29.3,4.6-45.2,8.1 C340.9,132.1,322.6,137.1,305.9,142.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.6,344.8c22.7-1.3,50.7-1.1,82.3,3.2c29.7,4.1,55.2,10.8,75.8,17.7c3.7-25.4,9.7-54.3,19.4-85.5 c14.4-46.4,32.9-84.8,50-114.5c-11.8,0-23.7,0-35.5,0c-2.2,0-4.3,0-6.5,0c0,2.2,0,4.3,0,6.5c2.9-0.3,7.6-0.3,12.9,1.6 c2.6,0.9,4.8,2.1,6.5,3.2c-11.5,21.4-23.4,46.7-33.9,75.8c-13.4,37.2-21.2,71.3-25.8,100c-5-2.1-12.8-5.2-22.6-8.1 c-8.2-2.4-42.6-11.9-88.7-6.5C274.2,339.3,262.5,341.1,248.6,344.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.5,345.6c18.4-3.3,40.1-5.9,64.5-6.5c27.7-0.6,52.2,1.7,72.6,4.8c7.9-43.9,20.1-92.9,38.7-145.2 c8.2-22.9,16.9-44.4,25.8-64.5c-13.4,0.5-26.9,1.1-40.3,1.6c0,2.2,0,4.3,0,6.5c3-0.7,7.6-1.2,12.9,0c1.8,0.4,3.5,1,4.8,1.6 c-5.5,14.6-10.9,29.6-16.1,45.2c-16.4,49.3-28.4,96.4-37.1,140.3c-12.7-1.6-27.4-2.4-43.6-1.6C297.6,329.5,269.5,337.7,249.5,345.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157995632014753894520000008885796197447624324_",
    gradientUnits: "userSpaceOnUse",
    x1: 248,
    y1: 346,
    x2: 248,
    y2: 121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1164,
    style: {
      stopColor: "#EAE5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2613,
    style: {
      stopColor: "#EBD5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    style: {
      stopColor: "#ECBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5916,
    style: {
      stopColor: "#ED9999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    style: {
      stopColor: "#EF6B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9546,
    style: {
      stopColor: "#F13535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F22626"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157995632014753894520000008885796197447624324_)"
    },
    d: "M386,212.6c-2.1,26.6-18.3,44.6-25,51.3 c-37.7,27.4-75.3,54.7-113,82.1c-37.7-27.4-75.3-54.7-113-82.1c-6.7-6.7-22.9-24.7-25-51.3c-3.4-42.4,31-81.9,68-90.1 c37.1-8.1,65.9,18.8,70,22.8c4.1-4,32.9-30.9,70-22.8C355,130.7,389.4,170.2,386,212.6z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsreadlogo);
export default __webpack_public_path__ + "static/media/letsreadlogo.c284108a0a68ad996d3a645397b06b23.svg";
export { ForwardRef as ReactComponent };